function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Vue from 'vue';
export default Vue.extend({
  name: 'mouse',
  methods: {
    getDefaultMouseEventHandlers: function getDefaultMouseEventHandlers(suffix, getEvent) {
      return this.getMouseEventHandlers(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, 'click' + suffix, {
        event: 'click'
      }), 'contextmenu' + suffix, {
        event: 'contextmenu',
        prevent: true,
        result: false
      }), 'mousedown' + suffix, {
        event: 'mousedown'
      }), 'mousemove' + suffix, {
        event: 'mousemove'
      }), 'mouseup' + suffix, {
        event: 'mouseup'
      }), 'mouseenter' + suffix, {
        event: 'mouseenter'
      }), 'mouseleave' + suffix, {
        event: 'mouseleave'
      }), 'touchstart' + suffix, {
        event: 'touchstart'
      }), 'touchmove' + suffix, {
        event: 'touchmove'
      }), 'touchend' + suffix, {
        event: 'touchend'
      }), getEvent);
    },
    getMouseEventHandlers: function getMouseEventHandlers(events, getEvent) {
      var _this = this;
      var on = {};
      var _loop = function _loop(event) {
        var eventOptions = events[event];
        if (!_this.$listeners[event]) return 1; // continue
        // TODO somehow pull in modifiers

        var prefix = eventOptions.passive ? '&' : (eventOptions.once ? '~' : '') + (eventOptions.capture ? '!' : '');
        var key = prefix + eventOptions.event;
        var handler = function handler(e) {
          var mouseEvent = e;
          if (eventOptions.button === undefined || mouseEvent.buttons > 0 && mouseEvent.button === eventOptions.button) {
            if (eventOptions.prevent) {
              e.preventDefault();
            }
            if (eventOptions.stop) {
              e.stopPropagation();
            }
            _this.$emit(event, getEvent(e));
          }
          return eventOptions.result;
        };
        if (key in on) {
          /* istanbul ignore next */
          if (Array.isArray(on[key])) {
            on[key].push(handler);
          } else {
            on[key] = [on[key], handler];
          }
        } else {
          on[key] = handler;
        }
      };
      for (var event in events) {
        if (_loop(event)) continue;
      }
      return on;
    }
  }
});